import { ChatCircle } from "@phosphor-icons/react"

export function GlobalAIThinking() {
  return (
    <div className="flex gap-3 items-start">
      {/* Avatar */}
      <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center bg-primary/10 text-primary">
        <ChatCircle className="h-4 w-4" />
      </div>

      {/* Thinking indicator */}
      <div className="flex items-center gap-1 pt-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40 animate-bounce [animation-delay:-0.3s]" />
        <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40 animate-bounce [animation-delay:-0.15s]" />
        <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40 animate-bounce" />
      </div>
    </div>
  )
}
